import React from 'react';
import StatusError from './StatusError';
import StatusUpdated from './StatusUpdated';

const Status = ({ error, updated_at }) => {
  if (error) return <StatusError />;
  if (updated_at) return <StatusUpdated updatedAt={updated_at} />;
  return null;
};

export default React.memo(Status);



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Status/Status.js